// TemplateSettingsSection — workflow-template-config (trigger-event +
// template-namn) som visas i PropertiesPanel för authenticated users.
// Verbatim extraherad ur PropertiesPanel.tsx (#8, POST_QA_SUBPLAN
// Wave E.1).
//
// Ingen logikändring: state-ägaren förblir PropertiesPanel; den här
// komponenten är en ren presentational-section som tar
// kontrollerade-input props.

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useTranslation } from '@/i18n/LanguageContext';

interface TemplateSettingsSectionProps {
  triggerEvent: string;
  onTriggerEventChange: (next: string) => void;
  localWorkflowName: string;
  onLocalWorkflowNameChange: (next: string) => void;
  /** Anropas på blur + Enter — commit:ar localWorkflowName till parent. */
  onFlushWorkflowName: () => void;
}

export function TemplateSettingsSection({
  triggerEvent, onTriggerEventChange,
  localWorkflowName, onLocalWorkflowNameChange,
  onFlushWorkflowName,
}: TemplateSettingsSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="p-5 border-b border-border">
      <h2 className="font-semibold text-sm mb-4">{t('templateSettings')}</h2>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="trigger-event">{t('trigger')}</Label>
          <Select value={triggerEvent} onValueChange={onTriggerEventChange}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="user-created">{t('userCreated')}</SelectItem>
              <SelectItem value="user-modified">{t('userModified')}</SelectItem>
              <SelectItem value="user-deleted">{t('userDeleted')}</SelectItem>
              <SelectItem value="custom">{t('custom')}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="template-name">{t('name')}</Label>
          <Input
            id="template-name"
            value={localWorkflowName}
            onChange={(e) => onLocalWorkflowNameChange(e.target.value)}
            onBlur={onFlushWorkflowName}
            onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }}
            placeholder="T.ex. Onboarding"
          />
        </div>
      </div>
    </div>
  );
}
